function getFileUid(fileUrl: string) {
  return fileUrl.match(
    /([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})/,
  )?.[0] || null
}

export default getFileUid
